import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { HtsQuestionnaireList } from './HtsQuestionnaireList';
import { HtsQuestionnaireEditor } from './HtsQuestionnaireEditor';
import { ROUTES } from '@/routes';

/**
 * Mode router for the HTS Questionnaires admin surface: the list lives at
 * ADMIN_HTS_QUESTIONNAIRES, and the same full-page editor is reused for both
 * ADMIN_HTS_QUESTIONNAIRE_NEW (no :id) and ADMIN_HTS_QUESTIONNAIRE_EDIT (:id present).
 */
export const AdminHtsQuestionnaires: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const location = useLocation();
  const isNew = location.pathname === ROUTES.ADMIN_HTS_QUESTIONNAIRE_NEW;

  if (isNew) return <HtsQuestionnaireEditor />;
  if (id) return <HtsQuestionnaireEditor id={id} />;
  return <HtsQuestionnaireList />;
};

export default AdminHtsQuestionnaires;
